import { Model, type ModelProps } from '@/infra/model'
import { Id } from '@/infra/id'
import { action, observable } from 'mobx'
import type { ContactAddress } from './ContactAddress'
import type { FilingStatus } from '@taxfyle/txf-api-client'

export type TaxPayerProps = ModelProps<TaxPayer>

export class TaxPayer extends Model<TaxPayer> {
  id = Id.none

  @observable accessor firstName: string | null = null
  @observable accessor middleInitial: string | null = null
  @observable accessor lastName: string | null = null
  @observable accessor tin: string | null = null
  @observable accessor dob: Date | null = null
  @observable accessor phoneNumber: string | null = null
  @observable accessor emailAddress: string | null = null
  @observable accessor occupation: string | null = null
  @observable accessor filingStatus: FilingStatus | null = null

  @observable accessor contactAddress: ContactAddress | null = null

  @action.bound
  override set({ ...props }: Partial<TaxPayerProps>): this {
    return super.set(props)
  }

  toProps(): TaxPayerProps {
    return {
      id: this.id,
      firstName: this.firstName,
      middleInitial: this.middleInitial,
      lastName: this.lastName,
      tin: this.tin,
      dob: this.dob,
      phoneNumber: this.phoneNumber,
      emailAddress: this.emailAddress,
      occupation: this.occupation,
      filingStatus: this.filingStatus,
      contactAddress: this.contactAddress,
    }
  }
}
